import Reflux from 'reflux';
import axios from 'axios';
import ShowData from 'shared/data/Show';

const async = { asyncResult: true };
const PDFExportFormActions = Reflux.createActions({
  updateField: {},
  updateColumnVisibility: {},
  generatePDF: async,
  generateGuestPDF: async,
  togglePageBreak: {},
  submit: {},
  clear: {},
  clearPreset: {},
  createNewPreset: async,
  submitNewPreset: {},
  setPresetInState: {},
  updatePreset: {},
  updatePresetPersistent: async,
});

/**
 *
 * TODO: Zack implement as you see fit
 *
 * @param {} url
 */
function getPDF(pdfExportConfig) {
  return axios
    .post('/pdf', { params: pdfExportConfig })
    .then((res) => res.data);
}

PDFExportFormActions.generatePDF.listenAndPromise(getPDF);
PDFExportFormActions.generateGuestPDF.listenAndPromise(getPDF);
PDFExportFormActions.createNewPreset.listenAndPromise(ShowData.createPDFPreset);
PDFExportFormActions.updatePresetPersistent.listenAndPromise(
  ShowData.updatePDFPreset,
);

export default PDFExportFormActions;
